// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-page {
  background-color: rgba(var(--white));
}
.catalog-page__header {
  padding: 3rem 6.875rem 0;
}
@media (max-width: 768px) {
  .catalog-page__header {
    padding: 1.75rem 1rem 1.25rem;
    height: 2.5rem;
  }
}
.catalog-page__content {
  padding: 2rem 6.875rem 3rem;
}
@media (max-width: 768px) {
  .catalog-page__content {
    padding: 0;
  }
}
.catalog-page__search-result {
  padding-top: 3rem;
}
@media (max-width: 768px) {
  .catalog-page__search-result {
    padding: 2rem 1rem 1rem;
  }
}
.catalog-page__title {
  font-size: 2rem;
  line-height: 1.3;
  font-weight: 500;
  color: rgba(var(--grey-800));
}
@media (max-width: 768px) {
  .catalog-page__title {
    font-size: 1.5rem;
    line-height: 1.3;
    padding: 0 1rem;
    margin-top: 2rem;
  }
}
.catalog-page-blocks {
  display: flex;
  gap: 2.5rem;
  margin-top: 3rem;
}
@media (max-width: 768px) {
  .catalog-page-blocks {
    margin-top: 1.5rem;
    flex-direction: column;
  }
}
.catalog-page-tabs {
  display: flex;
  gap: 1rem;
  padding: 1rem 0 1rem;
}
@media (max-width: 1000px) {
  .catalog-page-tabs {
    position: relative;
    gap: 0.5rem;
    border-bottom: none;
    overflow-x: auto;
  }
}
@media (max-width: 768px) {
  .catalog-page-tabs {
    padding: 0 1rem 1.5rem;
  }
}
.catalog-page-tabs__empty {
  height: 41.59px;
}
@media (max-width: 768px) {
  .catalog-page-tabs__empty {
    height: 37.98px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Catalog/styles.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAKI,6BAAA;IACA,cAAA;EACJ;AACF;AAEE;EACE,2BAAA;AAAJ;AAEI;EAHF;IAII,UAAA;EACJ;AACF;AAEE;EACE,iBAAA;AAAJ;AAEI;EAHF;IAII,uBAAA;EACJ;AACF;AAEE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AAAJ;AAEI;EANF;IAOI,iBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;EACJ;AACF;AAEE;EACE,aAAA;EACA,WAAA;EACA,gBAAA;AAAJ;AAEI;EALF;IAMI,kBAAA;IACA,sBAAA;EACJ;AACF;AAEE;EACE,aAAA;EACA,SAAA;EACA,oBAAA;AAAJ;AAEI;EALF;IAMI,kBAAA;IACA,WAAA;IACA,mBAAA;IACA,gBAAA;EACJ;AACF;AACI;EAZF;IAaI,sBAAA;EAEJ;AACF;AAAI;EACE,eAAA;AAEN;AAAM;EAHF;IAII,eAAA;EAGN;AACF","sourcesContent":[".catalog-page {\n  background-color: rgba(var(--white));\n\n  &__header {\n    padding: 3rem 6.875rem 0;\n\n    @media (max-width: 768px) {\n      // padding: 2rem 1rem 1.5rem;\n      padding: 1.75rem 1rem 1.25rem;\n      height: 2.5rem;\n    }\n  }\n\n  &__content {\n    padding: 2rem 6.875rem 3rem;\n\n    @media (max-width: 768px) {\n      padding: 0;\n    }\n  }\n\n  &__search-result {\n    padding-top: 3rem;\n\n    @media (max-width: 768px) {\n      padding: 2rem 1rem 1rem;\n    }\n  }\n\n  &__title {\n    font-size: 2rem;\n    line-height: 1.3;\n    font-weight: 500;\n    color: rgba(var(--grey-800));\n\n    @media (max-width: 768px) {\n      font-size: 1.5rem;\n      line-height: 1.3;\n      padding: 0 1rem;\n      margin-top: 2rem;\n    }\n  }\n\n  &-blocks {\n    display: flex;\n    gap: 2.5rem;\n    margin-top: 3rem;\n\n    @media (max-width: 768px) {\n      margin-top: 1.5rem;\n      flex-direction: column;\n    }\n  }\n\n  &-tabs {\n    display: flex;\n    gap: 1rem;\n    padding: 1rem 0 1rem;\n\n    @media (max-width: 1000px) {\n      position: relative;\n      gap: 0.5rem;\n      border-bottom: none;\n      overflow-x: auto;\n    }\n\n    @media (max-width: 768px) {\n      padding: 0 1rem 1.5rem;\n    }\n\n    &__empty {\n      height: 41.59px;\n\n      @media (max-width: 768px) {\n        height: 37.98px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
